"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Radio_1 = __importDefault(require("@mui/material/Radio"));
var styles_1 = require("@mui/material/styles");
var colors_1 = require("../ThemeProvider/colors");
var radioSize = 20;
var dotSize = 8;
var BpIcon = (0, styles_1.styled)('span')(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: '50%',
        width: radioSize,
        height: radioSize,
        border: "1px solid ".concat(colors_1.tannerGray[600]),
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:disabled ~ &': {
            backgroundColor: colors_1.tannerGray[100],
            borderColor: colors_1.tannerGray[300],
        },
    });
});
var BpCheckedIcon = (0, styles_1.styled)(BpIcon)({
    backgroundColor: colors_1.tannerSemantic.info.color,
    border: 'none',
    '&:before': {
        position: 'absolute',
        width: dotSize,
        height: dotSize,
        left: 'calc(50% - 8px/2)',
        top: 'calc(50% - 8px/2)',
        background: colors_1.tannerWhite,
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)',
        borderRadius: '50%',
        content: '""',
    },
    'input:disabled ~ &': {
        backgroundColor: colors_1.tannerSemantic.info.color,
        opacity: '0.3',
    },
});
var BpRadio = (0, styles_1.styled)(Radio_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(3),
        '&:hover': {
            backgroundColor: "".concat(colors_1.tannerSemantic.info['200'], "46"),
        },
    });
});
var RadioButton = react_1.default.forwardRef(function (props, ref) { return (react_1.default.createElement(BpRadio, __assign({ ref: ref, color: "primary", checkedIcon: react_1.default.createElement(BpCheckedIcon, null), icon: react_1.default.createElement(BpIcon, null) }, props))); });
exports.default = RadioButton;
__exportStar(require("@mui/material/Radio"), exports);
//# sourceMappingURL=index.js.map